import React from 'react';
import './aim-hero-animated-bg.styles.css';

const AimHeroAnimatedBg = ({ children, className = '', variant = 'blue', customColors = null }) => {
  const sectionClasses = `aim-blurb-section aim-blurb-section--${variant} ${className}`;

  return (
    <div className="absolute top-0 left-0 w-full h-screen z-0 overflow-hidden">
      <section
        className={sectionClasses}
        style={
          customColors
            ? {
                '--primary-color': customColors.primary,
                '--secondary-color': customColors.secondary,
                '--accent-color': customColors.accent
              }
            : {}
        }
      >
        <div className="aim-blurb-section-content">{children}</div>
      </section>
    </div>
  );
};

export default AimHeroAnimatedBg;
